import React from "react";

function CompanyLogo({ size = 30, hiddenOnMobile = false, className = "" }) {
  return (
    <img
      style={{ height: size }}
      className={`w-auto ${hiddenOnMobile ? "hidden sm:block" : ""} ${className}`.trim()}
      src="https://on-the-strip-ticketing.s3.us-west-1.amazonaws.com/logos/logoLight.png"
      alt="On The Strip Ticketing"
    />
  );
}

export default CompanyLogo;
